module.exports = __webpack_public_path__ + "static/media/1997 London, UK.aafd9782.jpg";